import React from "react";

import translations from "./translations";

// Format: `languageCode_countryCode` (eg. en_US, de_DE)
// @see https://en.wikipedia.org/wiki/IETF_language_tag
enum Locale {
  de = "de_DE",
  DE = "de_DE",
  de_AT = "de_DE",
  de_CH = "de_DE",
  de_DE = "de_DE",
  en = "en_US",
  EN = "en_US",
  en_GB = "en_US",
  en_US = "en_US",
}

export type LocaleProps = {
  locale?: string;
  i18n?: { [key: string]: any };
};

export type LocaleState = {
  locale: string;
  translation?: any;
};

export interface ILocaleContext {
  locale?: string;
  translation?: any;
  switchLocale?: Function;
}

const defaultLocaleState = {
  locale: "de_DE",
  translation: (translations as any).de_DE,
};

const LocaleContext = React.createContext<ILocaleContext>(defaultLocaleState);

export class LocaleProvider extends React.Component<LocaleProps, LocaleState> {
  constructor(props: any) {
    super(props);
    const locale =
      (Locale as { [key: string]: string })[props.locale] ||
      defaultLocaleState.locale;

    this.state = {
      locale: locale,
      translation: (translations as any)[locale],
    };
  }

  public render(): JSX.Element {
    return (
      <LocaleContext.Provider
        value={{
          ...this.state,
          switchLocale: this.switchLocale,
        }}
      >
        {this.props.children}
      </LocaleContext.Provider>
    );
  }

  public switchLocale(): void {
    this.setState((prevState: any) => {
      const newLocale = prevState.locale === "de_DE" ? "en_US" : "de_DE";
      return {
        locale: newLocale,
        translation: (translations as any)[newLocale],
      };
    });
  }
}

export const withLocale = <P extends {}>(
  WrappedComponent: React.ComponentClass<P> | React.FC<P>
) => (props: P & LocaleProps) => {
  return (
    <LocaleContext.Consumer>
      {(value: any) => <WrappedComponent {...props} i18n={value.translation} />}
    </LocaleContext.Consumer>
  );
};

export const LocaleConsumer = LocaleContext.Consumer;

export default LocaleContext;
